import React from 'react';
import {Container, Card, Button} from 'react-bootstrap';
import {FaDownload, FaFilePdf} from 'react-icons/fa'; // Icons for a modern look
import {FRONT_END_URL} from '../../config';

const LeavePolicy: React.FC = () => {
  const pdfUrl = `${FRONT_END_URL}/LeavePolicy.pdf`; // Adjust path as needed

  return (
    <Container
      className="d-flex justify-content-center align-items-center p-3"
      fluid
    >
      <Card
        className="border-0 text-center"
        style={{
          borderRadius: '15px',
          width: '100%',
          backgroundColor: '#f8f9fa'
        }}
      >
        <Card.Body>
          <div className="d-flex align-items-center justify-content-center flex-column mb-4">
            <FaFilePdf size={50} className="text-danger mb-3" />
            <Card.Title
              className="fw-bold text-dark"
              style={{fontSize: '1.5rem'}}
            >
              Leave Policy
            </Card.Title>
          </div>

          <Card.Text className="text-muted mb-4" style={{fontSize: '1rem'}}>
            Please read the company&apos;s leave policy carefully. You can
            download the document below.
          </Card.Text>

          {/* Embed PDF */}
          <div className="mb-4">
            <embed
              src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
              type="application/pdf"
              width="100%"
              height="400px" // Use vh for responsive height
              style={{
                borderRadius: '10px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)'
              }}
            />
          </div>

          {/* Download Button */}
          <div className="d-flex justify-content-center align-items-center ">
            <a
              href={pdfUrl}
              download="Artzen-Leave-Policy.pdf"
              className="text-decoration-none"
            >
              <Button
                variant="primary"
                className="d-flex justify-content-center align-items-center py-3 px-4 rounded-lg"
                style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  backgroundImage: 'linear-gradient(45deg, #007bff, #00c6ff)',
                  borderColor: '#007bff',
                  transition: 'all 0.3s ease',
                  padding: '15px 30px'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundImage =
                    'linear-gradient(45deg, #0056b3, #0099cc)';
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundImage =
                    'linear-gradient(45deg, #007bff, #00c6ff)';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                <FaDownload style={{marginRight: '10px'}} />{' '}
                {/* Added margin to create gap */}
                Download PDF
              </Button>
            </a>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default LeavePolicy;
